export const DEEPSEEK_API_KEY = "sk-f05faa772b5541879936eddd342cb305";